import { useState } from 'react';
import { Elements, ExpressCheckoutElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import backendAxios from '../../utils/backendAxios';

// Misma instancia de Stripe que StripeCard (se carga una sola vez a nivel de módulo).
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

// Botón de wallet (Apple Pay / Google Pay). Como el cargo real ocurre al aceptar la
// reserva, aquí NO se cobra: la wallet solo autoriza y GUARDA la tarjeta mediante un
// SetupIntent (uso off_session), igual que el campo de tarjeta. Devuelve el mismo pm_...
// que el backend ya sabe cobrar; por eso F4B no toca nada del backend.
const WalletInner = ({ validar, onPago, onError, onDisponible }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [visible, setVisible] = useState(true);

  // El elemento avisa qué wallets puede ofrecer este navegador/dispositivo. Si no hay
  // ninguna (p. ej. Chrome sin Google Pay, o dev sin dominio Apple), se oculta la sección.
  const alListo = (event) => {
    const hay = event?.availablePaymentMethods && Object.keys(event.availablePaymentMethods).length > 0;
    setVisible(!!hay);
    onDisponible && onDisponible(!!hay);
  };

  // Antes de abrir la hoja nativa validamos el resto del formulario (horario, etc.).
  // Si algo falta, no resolvemos: la hoja no se abre y mostramos el error por fuera.
  const alHacerClick = (event) => {
    if (validar && !validar()) return;
    event.resolve();
  };

  // El usuario autorizó en la wallet. Confirmamos el SetupIntent para guardar la tarjeta
  // y entregamos el paymentMethod resultante al contenedor (crea la reserva con él).
  const alConfirmar = async () => {
    if (!stripe || !elements) return;
    try {
      const { error: submitError } = await elements.submit();
      if (submitError) { onError && onError(submitError.message || 'No se pudo procesar la wallet.'); return; }

      const { data } = await backendAxios.post('/api/payments/stripe/setup-intent');
      const { error, setupIntent } = await stripe.confirmSetup({
        elements,
        clientSecret: data.clientSecret,
        confirmParams: { return_url: window.location.href },
        redirect: 'if_required',
      });
      if (error) { onError && onError(error.message || 'La wallet fue rechazada. Intenta con otro método.'); return; }
      onPago && onPago(setupIntent.payment_method); // pm_... (mismo contrato que la tarjeta)
    } catch (_) {
      onError && onError('No se pudo procesar el pago con la wallet.');
    }
  };

  if (!visible) return null;

  return (
    <ExpressCheckoutElement
      options={{ buttonHeight: 48, buttonTheme: { applePay: 'black', googlePay: 'black' } }}
      onReady={alListo}
      onClick={alHacerClick}
      onConfirm={alConfirmar}
    />
  );
};

// Envoltura con su PROPIO <Elements mode:'setup'>, aislado del <Elements> de StripeCard.
// Así el campo de tarjeta (ya verificado) no se toca al agregar las wallets.
const StripeWallets = (props) => (
  <Elements stripe={stripePromise} options={{ mode: 'setup', currency: 'mxn' }}>
    <WalletInner {...props} />
  </Elements>
);

export default StripeWallets;
